export default __webpack_public_path__ + "static/media/external_site.902207f3.svg";